export default "__VITE_ASSET__BWqxZRNC__"